import React from "react";

export type ContainerPropsType = {
    [x: string]: any;
    justifyContent?:
        | "normal"
        | "space-between"
        | "space-around"
        | "space-evenly"
        | "stretch"
        | "unsafe"
        | "safe"
        | "center"
        | "start"
        | "end"
        | "flex-start"
        | "flex-end"
        | "left"
        | "right";
    alignItems?:
        | "normal"
        | "stretch"
        | "baseline"
        | "first baseline"
        | "last baseline"
        | "unsafe"
        | "safe"
        | "center"
        | "start"
        | "end"
        | "self-start"
        | "self-end"
        | "flex-start"
        | "flex-end";
    flexWrap?: "wrap" | "nowrap" | "wrap-reverse";
    className?: string;
};

export function Container({
    type,
    justifyContent,
    alignItems,
    flexWrap,
    className,
    ...props
}: ContainerPropsType & { type: "column" | "row" }) {
    if (!("style" in props)) {
        props.style = {};
    }

    if (justifyContent) {
        props.style.justifyContent = justifyContent;
    }

    if (alignItems) {
        props.style.alignItems = alignItems;
    }

    if (flexWrap) {
        props.style.flexWrap = flexWrap;
    }

    return (
        <div style={{}} className={"grid-container " + type + " " + (className ?? "")} {...props} />
    );
}

export function GridColumn(props: ContainerPropsType) {
    return <Container type={"column"} {...props} />;
}

export function GridRow(props: ContainerPropsType) {
    return <Container type={"row"} {...props} />;
}

export const GridItem = React.forwardRef(
    (
        { className, ...props }: { [x: string]: any; className?: string },
        ref: React.ForwardedRef<HTMLDivElement>
    ) => {
        return <div ref={ref} className={"item " + (className ?? "")} {...props} />;
    }
);
